import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { LogMessageActions } from '.';
import { LogMessagesService } from '../services/log-messages.service';

@Injectable()
export class LogMessageEffects {
  private actions$ = inject(Actions);
  private logMessagesService = inject(LogMessagesService);

  loadLogMessagesPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LogMessageActions.LOAD_PAGE),
      map((action: LogMessageActions.LoadLogMessagesPage) => action?.payload),
      switchMap(payload =>
        this.logMessagesService
          .loadLogMessages(payload.rsqlFilter, payload.filterValues, payload.offset, payload.pageSize, payload.sortColumn, payload.sortDirection)
          .pipe(
            map(response => {
              if (response.error) {
                return new LogMessageActions.LoadLogMessagesPageFailed({
                  ...payload,
                  error: response.error,
                });
              }

              return new LogMessageActions.LoadLogMessagesPageSuccessful({
                ...payload,
                response: response,
              });
            }),
            catchError(error => of(new LogMessageActions.LoadLogMessagesPageFailed(error)))
          )
      )
    )
  );
}
